class DocumentationPath {

    constructor() {

        this.PATH_NORMAL_MODE = 1;
        this.PATH_WIZARD_MODE = 2;
        this.PATH_WALL_MODE = 3;
        this.PATH_MONO_MODE = 4;

        this._documentationPathData = null;
        this._documentationPathLms = new DocumentationPathLms();
        this._documentationPathUtils = new DocumentationPathUtils();

        this._keepTheLoop = new KeepTheLoop();
        window.instanceOfKeepTheLoop = this._keepTheLoop;

        this._wizardMode = null;
        this._monoMode = null;
        this._wallMode = null;

        this._popUpLockedContentTemplate = null;
        this._popUpAssessmentResultsTemplate = null;
        this._popUpPathCompletedTemplate = null;

        this._indexAnimationWidth = "90%";
        this._bottomOptionsAnimationWidth = 50;
        this._indexAnimationSpeed = 250;
        this._lastYScrollPosition = null;

        this._returnToPath = false;
        this._openTestOnLoad = false;
        this._isLmsPath = false;
        this._wizardItemIndex = null;

        this._loadTemplates();
        this._loadPartialTemplates();

    }

    _loadTemplates() {

        this._popUpLockedContentTemplate = Handlebars.compile($("#pathLockedContentPopUp").html());
        this._popUpAssessmentResultsTemplate = Handlebars.compile($("#pathAssessmentResultsPopUp").html());
        this._popUpPathCompletedTemplate = Handlebars.compile($("#pathCompletedPopUp").html());

    }

    _loadPartialTemplates() {

        Handlebars.registerPartial("pathWallFragment", $("#pathWallFragment").html());

        Handlebars.registerPartial("pathMonoFragment", $("#pathMonoFragment").html());
        Handlebars.registerPartial("pathMonoWallIndexFragment", $("#pathMonoWallIndexFragment").html());

        Handlebars.registerPartial("pathWizardFragment", $("#pathWizardFragment").html());
        Handlebars.registerPartial("pathWizardItemPreviewFragment", $("#pathWizardItemPreviewFragment").html());
        Handlebars.registerPartial("pathWizardDashboard", $("#pathWizardDashboard").html());

        Handlebars.registerPartial("pathFragment", $("#pathFragment").html());
        Handlebars.registerPartial("pathDashboard", $("#pathDashboard").html());
        Handlebars.registerPartial("pathIndexFragment", $("#pathIndexFragment").html());

    }

    _enableHandlers() {
        $("div.close-index-button").on("click.closeIndex", this.hideIndex.bind(this));

        setTimeout(() => {
            $("div.path-action-button").on("click.actionButton", this._onClickActionButton.bind(this));
        }, 400)

        $("div.action-button.is-path-normal.has-course").on("click.courseButton", this.onClickCourseButton.bind(this));
        $("div.action-button.is-path-normal.has-assessment").on("click.assessmentButton", this.onClickAssessmentButton.bind(this));
        $("div.action-button.is-path-normal.has-test").on("click.testButton", this.onClickTestButton.bind(this));
        $("div.action-button.is-path-normal.has-game").on("click.gameButton", this.onClickGameButton.bind(this));
        $("div.action-button.has-outstanding-material, div.bf-smart-list.path-material-item").on("click.outstandingMaterialButton", this._onClickMaterialButton.bind(this));
        $("div.bf-smart-list.path-course-item").on("click.pathClass", this.onClickClassButton.bind(this));
        $("div.bf-smart-list.path-course-test .action-button").on("click.pathTest", this.onClickTestButton.bind(this));

        document.querySelector('li.nav-item.courses-nav-item')?.addEventListener('click', () => {
            sessionStorage.setItem('navigation-tab', 'courses');
        });

        document.querySelector('li.nav-item.materials-nav-item')?.addEventListener('click', () => {
            sessionStorage.setItem('navigation-tab', 'materials');
        });

        //little hack - when open a document if material tab is active, when back to panel, tab material will be active
        if(sessionStorage.getItem('navigation-tab') === 'materials') {
            const el = document.querySelector('#materials-tab');

            if(el) {
                setTimeout(() => {
                    el.click();
                    sessionStorage.removeItem('navigation-tab');
                }, 50);
            }
        }
    }

    // `keepPathState`: refresca solo los datos del path sin recrear `DocumentationPathData`, para no
    // perder el estado de navegación (`pathDocumentId`, índice abierto...) mientras se está dentro de
    // un contenido del path (p. ej. el refresco en segundo plano de `checkAndRefreshPathCompletion`).
    getPath(pathId, onSuccessFunction, showModalLoading = true, keepPathState = false) {

        function _onGetPathSuccess(response) {

            if (api.checkisValidResult(response)) {

                let pathData = response.result.path;

                pathData = that._documentationPathUtils.parseJsonResponse(pathData);
                that._documentationPathData.setPathData(pathData);

                onSuccessFunction(that._documentationPathData.getPathData());

                that.updateSmartListPathProgress(pathData.document_root.id, pathData);
                that.updateSmartListPathIndicators(pathData.document_root.id, pathData);

                // El path ya no se marca "en progreso" solo por acceder; refleja en el listado
                // (react-zustand e icono legacy) el estado que calcula backend a partir de sus contenidos.
                const documentationProgress = documentationScreenController.documentationProgress;
                if (pathData.progressState.state === documentationProgress.IN_PROCESS) {
                    // El store de React compara ids con `===`.
                    documentationProgress.setInProgress(parseInt(pathData.document_root.id));
                } else if (pathData.progressState.state === documentationProgress.COMPLETED) {
                    // Igual que IN_PROCESS: si no se sincroniza, el listado conserva el estado "en progreso"
                    // aunque backend ya devuelva el path completado (p. ej. al aprobar el test del path).
                    // isNewlyCompleted=false: la celebración la gestiona checkAndRefreshPathCompletion.
                    documentationProgress.markCompletedLocally(parseInt(pathData.document_root.id), 0, null, false);
                }

            }

        }

        const that = this;

        if (!keepPathState) {
            // `closeDocumentDetails(returnToPath)` necesita el id del documento del path mientras llega esta
            // respuesta (p. ej. al terminar un test, goToMainApp recarga el path y pulsa "cerrar" antes de que
            // `initialize()` vuelva a fijarlo): sin él, getDocument(null) devuelve null y el cierre revienta.
            const previousPathDocumentId = this._documentationPathData?.getPathDocumentId?.();

            this._documentationPathData = new DocumentationPathData();

            if (previousPathDocumentId) {
                this._documentationPathData.setPathDocumentId(previousPathDocumentId);
            }
        }

        api.getPath(pathId, _onGetPathSuccess, showModalLoading);

    }

    getPathModes() {

        return {
            NORMAL_MODE: this.PATH_NORMAL_MODE,
            WIZARD_MODE: this.PATH_WIZARD_MODE,
            WALL_MODE: this.PATH_WALL_MODE,
            MONO_MODE: this.PATH_MONO_MODE
        }

    }

    getPathUtils() {
        return this._documentationPathUtils;
    }

    getPathData() {
        if (!this._documentationPathData) {
            return {};
        }

        return this._documentationPathData.getPathData();
    }

    getBlockers() {
        return this._documentationPathData.getBlockers();
    }

    getPathDocumentId() {
        return this._documentationPathData.getPathDocumentId();
    }

    getReturnToPath() {
        return this._returnToPath;
    }

    getReturnToPathWizardPreview() {
        return this._wizardMode ? this._wizardMode.getReturnToPathWizardPreview() : null;
    }

    getOpenTestOnLoad() {
        return this._openTestOnLoad;
    }

    getIsLmsPath() {
        return this._isLmsPath;
    }

    getLastYScrollPosition() {
        return this._lastYScrollPosition;
    }

    setLastYScrollPosition(lastYScrollPosition) {
        return this._lastYScrollPosition = lastYScrollPosition;
    }

    setOpenTestOnLoad(openTest) {
        this._openTestOnLoad = openTest;
    }

    setReturnToPath(returnToPath) {
        this._returnToPath = returnToPath;
    }

    setReturnToPathWizardPreview(document) {
        this._wizardMode.setReturnToPathWizardPreview(document)
    }

    setLmsPath(isLms) {
        this._isLmsPath = isLms;
    }

    setWizardItemIndex(index) {
        this._wizardItemIndex = index;
    }

    showKeepTheLoop() {
        this._keepTheLoop.show();
    }

    hideKeepTheLoop() {
        this._keepTheLoop.hide();
    }

    deleteKeepTheLoop() {
        this._keepTheLoop.deleteKeepTheLoop();
    }

    enableWizardPreviewHandlers() {
        this._wizardMode.enablePreviewHandlers();
    }

    _onClickActionButton(event) {
        function _toggleIndexCourses() {

            const $courseTab = $("#courses-tab");
            const $coursesNav = $("li.courses-nav-item");
            const $materialsTab = $("#materials-tab");
            const $materialsNav = $("li.materials-nav-item");

            // Si esta pulsando los botones de la cover del path con el indice abierto cambiar solamente de pestañas del indice (no cerrarlo)
            if (that._documentationPathData.getIsIndexOpened() && $materialsTab.length > 0 && $materialsNav.hasClass("active")) {
                $courseTab.trigger("click");
                return;
            }

            $courseTab.trigger("click");

            if (that._documentationPathData.getIsIndexOpened()) {
                that.hideIndex();
                that._documentationPathData.setIndexOpened(false);
            } else {
                that.showIndex();
                that._documentationPathData.setIndexOpened(true);
            }

        }

        function _toggleIndexMaterials() {

            const $courseTab = $("#courses-tab");
            const $coursesNav = $("li.courses-nav-item");
            const $materialsTab = $("#materials-tab");
            const $materialsNav = $("li.materials-nav-item");

            // Si esta pulsando los botones de la cover del path con el indice abierto cambiar solamente de pestañas del indice (no cerrarlo)
            if (that._documentationPathData.getIsIndexOpened() && $courseTab.length > 0 && $coursesNav.hasClass("active")) {
                $materialsTab.trigger("click");
                return;
            }

            $materialsTab.trigger("click");

            if (that._documentationPathData.getIsIndexOpened()) {
                that.hideIndex();
                that._documentationPathData.setIndexOpened(false);
            } else {
                that.showIndex();
                that._documentationPathData.setIndexOpened(true);
            }

        }

        function _openInformationTab() {

            const $documentDetailsToggleButton = $("#document-details-toggle-button");
            const $informationTab = $("#information-tab");

            // Si esta el indice abierto cerrarlo y despues abrir la ficha
            if (that._documentationPathData.getIsIndexOpened()) {

                that.hideIndex();
                that._documentationPathData.setIndexOpened(false);

                setTimeout(function () {
                    $informationTab.trigger("click");
                    $documentDetailsToggleButton.trigger("click");
                }, that._indexAnimationSpeed);

            } else {

                $informationTab.trigger("click");
                $documentDetailsToggleButton.trigger("click");

            }

            // Mostrar la ficha y desplegarla para los paths curso
            if (pathData.mode !== that.PATH_NORMAL_MODE) {

                const $pathDashboard = $("div.path-dashboard[data-pathmode=" + pathData.mode + "]").show();
                const $closeDrawerButtons = $("#document-details-toggle-button, #document-details-content .close-button");

                $pathDashboard.show();

                $closeDrawerButtons.one("click.closeDrawer", function () {
                    setTimeout(function () {
                        $pathDashboard.hide();
                        $closeDrawerButtons.off("click.closeDrawer");
                    }, 400);

                });

            }

        }

        function _openCommentsTab() {

            const documentId = $this.data("document");
            const $documentDetailsToggleButton = $("#document-details-toggle-button");
            const $commentsTab = $("#comments-tab");
            const $commentButton = $("#documentComment-" + documentId + "-details");

            $documentDetailsToggleButton.trigger("click");

            // Esperar a que se despliegue la ficha para abrir la sección para comentar
            setTimeout(function () {
                $commentButton.trigger("click");
            }, 400);

            // Mostrar la ficha y desplegarla para los paths curso
            if (pathData.mode !== that.PATH_NORMAL_MODE) {

                const $pathDashboard = $("div.path-dashboard[data-pathmode=" + pathData.mode + "]").show();
                const $closeDrawerButtons = $("#document-details-toggle-button, #document-details-content .close-button");

                $pathDashboard.show();

                $closeDrawerButtons.one("click.closeDrawer", function () {
                    setTimeout(function () {
                        $pathDashboard.hide();
                        $closeDrawerButtons.off("click.closeDrawer");
                    }, 400);

                });

            }

        }

        function _markFavourite() {

            const documentId = $this.data("document");
            const $markFavouriteButton = $(".mark-favourite[data-document=" + documentId + "]");

            $markFavouriteButton.trigger("click");

        }

        function _markLike() {

            const documentId = $this.data("document");
            const $markLikeButton = $(".mark-liked[data-document=" + documentId + "]");

            $markLikeButton.trigger("click");

        }

        const $this = $(event.currentTarget);
        const that = this;
        const type = $this.data("action");
        const actionTypes = this._documentationPathData.getButtonActionTypes();
        const pathData = this._documentationPathData.getPathData();

        switch (type) {

            case actionTypes.ACTION_BUTTON_INDEX:
                _toggleIndexCourses();
                break;

            case actionTypes.ACTION_BUTTON_MATERIALS:
                _toggleIndexMaterials();
                break;

            case actionTypes.ACTION_BUTTON_INFORMATION:
                _openInformationTab();
                break;

            case actionTypes.ACTION_BUTTON_COMMENT:
                _openCommentsTab();
                break;

            case actionTypes.ACTION_BUTTON_FAVOURITE:
                _markFavourite();
                break;

            case actionTypes.ACTION_BUTTON_LIKE:
                _markLike();
                break;

        }

    }

    onClickCourseButton(event) {

        const $this = $(event.currentTarget);
        const pathData = this._documentationPathData.getPathData();

        if ($this.hasClass("is-not-started") || $this.hasClass("is-completed")) {

            const firstClass = this._documentationPathUtils.getFirstClass(pathData);
            const firstClassId = firstClass.pathItemId;
            const $firstClass = $("div.bf-smart-list.path-course-item[data-item-id=" + firstClassId + "]");

            $firstClass.trigger("click");

        }

        if ($this.hasClass("is-in-process")) {

            const nextClass = pathData.nextDocumentToComplete;
            const nextClassId = nextClass.pathItemId;
            const $nextClass = $("div.bf-smart-list.path-course-item[data-item-id=" + nextClassId + "]");

            $nextClass.trigger("click");

        }

    }

    onClickAssessmentButton(event) {

        const $this = $(event.currentTarget);
        const pathDocumentId = $this.data("id");
        const pathData = this._documentationPathData.getPathData();
        const pathDocument = documentationScreenController.getDocument(pathDocumentId);
        const gameDocument = pathData.assessment ? pathData.assessment.game : null;
        const testDocument = pathData.assessment ? pathData.assessment.test : null;

        if (gameDocument) {
            gameDocument.own_game.is_path_assessment_game = true;
            documentationScreenController.startDocumentTypeGameOrTest(gameDocument, null, pathDocument);
        }

        if (testDocument) {
            testDocument.own_test.is_path_assessment_test = true;
            documentationScreenController.startDocumentTypeGameOrTest(null, testDocument, pathDocument);
        }

    }

    onClickTestButton(event) {
        function _onChangeDocumentDetails() {

            const $closeDetailsButton = $("#documentation-header-close-btn");

            $closeDetailsButton.trigger("click");
            that.setReturnToPath(true);

            // Al reabrir el test tras finalizarlo (setOpenTestOnLoad) el detalle del test original sigue
            // apilado debajo; si no se retira, reaparece "No intentado" al salir del path.
            $("#legacyStack section").has(".doc-details-TEST").remove();

        }

        const pathData = this._documentationPathData.getPathData();
        const testDocument = pathData.test.document;
        const that = this;

        testDocument.isPathTestContent = true;
        testDocument.own_test.is_path_assessment_test = false;

        _onChangeDocumentDetails();

        documentationScreenController.drawDocumentDetails(null, testDocument, null, documentationScreenController.documentation);

    }

    onClickGameButton(event) {

        const $this = $(event.currentTarget);
        const pathDocumentId = $this.data("id");
        const pathData = this._documentationPathData.getPathData();
        const gameDocument = pathData.game.document;

        gameDocument.own_game.is_path_assessment_game = false;
        gameDocument.own_game.belonging_to_path_id = pathDocumentId;
        gameDocument.isPathGameContent = true;

        if (gameDocument) {

            const $closeDetailsButton = $("#documentation-header-close-btn");

            $closeDetailsButton.trigger("click");
            this.setReturnToPath(true);

            documentationScreenController.drawDocumentDetails(null, gameDocument);

        }

    }

    _onClickMaterialButton(event) {

        function _onChangeDocumentDetails() {

            const $closeDetailsButton = $("#documentation-header-close-btn");

            $closeDetailsButton.trigger("click");
            that.setReturnToPath(true);

        }

        function _onGetItemDataSuccess(response) {

            if (api.checkisValidResult(response)) {

                const document = documentationScreenController.getDocument(response.result.document.id);

                _onChangeDocumentDetails();

                documentationScreenController.drawDocumentDetails(null, document, null, documentationScreenController.documentation);

            }

        }

        const $this = $(event.currentTarget);
        const materialId = $this.data("item-id");
        const that = this;

        api.getPathItem(materialId, _onGetItemDataSuccess);

    }

    onClickClassButton(event, openDocumentOption = null) {

        function _onChangeDocumentDetails() {

            const $closeDetailsButton = $("#documentation-header-close-btn");

            $closeDetailsButton.trigger("click");

            that._keepTheLoop.createKeepTheLoop();
            // that._documentationPathUtils.setKeepTheLoopEllipsis();

            that._keepTheLoop.setKeepTheLoopData(document, nextDocument, previousDocument, pathData);
        }

        function _onGetItemDataSuccess(response) {

            if (api.checkisValidResult(response)) {

                pathData = that._documentationPathData.getPathData();
                document = documentationScreenController.getDocument(response.result.document.id);
                nextDocument = response.result.next;
                previousDocument = response.result.previous;

                document.isPathClassContent = true;
                document.classId = response.result.item.id;

                _onChangeDocumentDetails();

                documentationScreenController.drawDocumentDetails(null, document, null, documentationScreenController.documentation);

            }

        }

        const $this = $(event.currentTarget);
        let pathData = null;
        let document = null;
        let nextDocument = null;
        let previousDocument = null;
        const contentBlocked = $this.data("blocked");
        const classId = $this.data("item-id");
        const that = this;

        if (contentBlocked) {
            this.openBlockedContentPopUp();
        } else {
            api.getPathItem(classId, _onGetItemDataSuccess);
        }


    }

    onCompletedClass(document, earnedPoints) {

        const pathData = this._documentationPathData.getPathData();
        const updatedPathData = this._documentationPathUtils.markSectionDocumentAsCompleted(pathData, document.id);

        this._documentationPathData.setPathData(updatedPathData);

        // El pastil decide candado/flecha según los ítems de la sección ya completados (ver
        // KeepTheLoop::chooseNextContentAnimationIcon): debe ejecutarse DESPUÉS de marcar este
        // contenido, si no el último contenido de una sección dejaba el siguiente bloqueado.
        this._keepTheLoop.showPointsPastil(earnedPoints);

        // IZE-9629: checkAndRefreshPathCompletion solo se disparaba desde el flujo de wizard preview
        // (DocumentationScreenController.js). Los contenidos completados en el resto de modos
        // (Course/Standard, Express/Instagram/Wall) llegan aquí vía isPathClassContent y también
        // deben poder completar el path.
        this.checkAndRefreshPathCompletion(pathData.id, this._documentationPathData.getPathDocumentId());

    }

    // IZE-9629 (FR-013, revierte TASK-006): la completitud del Learning Path la resuelve backend de
    // forma autoritativa al persistir la completitud de cada contenido hijo, sin ningún endpoint
    // propio del path. El frontend solo refresca el path ya persistido (mismo `getPath` de lectura
    // usado al abrirlo) y detecta la transición "no completado → completado" para disparar el modal.
    checkAndRefreshPathCompletion(pathId, pathDocumentId) {
        const that = this;
        const wasCompletedBefore =
            this._documentationPathData.getPathData().progressState.state ===
            documentationScreenController.documentationProgress.COMPLETED;

        this.getPath(pathId, function (refreshedPathData) {
            const isCompletedNow =
                refreshedPathData.progressState.state ===
                documentationScreenController.documentationProgress.COMPLETED;

            if (isCompletedNow && !wasCompletedBefore) {
                documentationScreenController.documentationProgress.markCompletedLocally(pathDocumentId);
                that.onCompletedPath();
            }
        }, false, true); // showModalLoading: false y keepPathState: true - refresco en segundo plano, no una navegación

    }

    onCompletedPath() {

        this.openPathCompletedPopUp();

        // IZE-9629: el refresco de checkAndRefreshPathCompletion ya trae progressState correcto desde
        // backend (getPath -> getPathProgress, que prioriza document.completed), por lo que este
        // forzado manual es redundante. Se mantiene como refuerzo defensivo por si onCompletedPath
        // se invoca alguna vez sin pasar antes por el refresco (p.ej. futuros disparadores).
        const pathData = this._documentationPathData.getPathData();
        const documentationProgress = documentationScreenController.documentationProgress;

        pathData.progressState.percentage = 100;
        pathData.progressState.state = documentationProgress.COMPLETED;

        this._documentationPathData.setPathData(pathData);

    }

    openPathCompletedPopUp() {

        const context = {
            world: world,
        };

        popUpController.setPopUp(this._popUpPathCompletedTemplate, context);
        popUpController.showPopUp("bottom");

        const $closePopUpButton = $("div.action-button.path-completed-confirm-button");
        $closePopUpButton.one("click.hidePopUp", popUpController.hidePopUp.bind(popUpController));

    }

    openBlockedContentPopUp() {

        const pathData = this._documentationPathData.getPathData();
        const blockers = this._documentationPathData.getBlockers();
        const context = {
            world: world,
            pathData: pathData,
            blockers: blockers,
            lockedByRequirement: this._documentationPathUtils.getBlockedByRequirement(blockers, pathData.blockers),
            lockedByDate: this._documentationPathUtils.getBlockedByDate(blockers, pathData.blockers),
            lockedByAssessment: pathData.assessment && pathData.assessment.enabled && !pathData.assessment.did_it,
            lockedTest: pathData.test && pathData.test.enabled && pathData.test.document.isBlocked,
        };

        popUpController.setPopUp(this._popUpLockedContentTemplate, context);
        popUpController.showPopUp("bottom");

        const $closePopUpButton = $("div.action-button.locked-content-confirm-button");
        $closePopUpButton.one("click.hidePopUp", popUpController.hidePopUp.bind(popUpController));

    }

    openAssessmentResultsPopUp(document) {

        const assessmentLevels = this._documentationPathData.getAssessmentLevels();
        const totalPoints = document.own_game ? document.own_game.games[0].total_points : document.own_test.games[0].total_points;
        const userPosition = document.own_game ? parseInt(document.own_game.user_rank) : null;
        const context = {
            world: world,
            pointsEarned: totalPoints,
            userPosition: userPosition,
            assessmentLevels: assessmentLevels,
            assessmentLevel: this._documentationPathUtils.getAssessmentLevel(document, assessmentLevels),
            pathData: this._documentationPathData.getPathData(),
        };

        popUpController.setPopUp(this._popUpAssessmentResultsTemplate, context);
        popUpController.showPopUp("bottom");

        const $closePopUpButton = $("div.action-button.path-assessment-confirm-button");
        $closePopUpButton.one("click.hidePopUp", popUpController.hidePopUp.bind(popUpController));

    }

    showIndex() {

        const $screenHeader = $("#documentation-full-screen-header");
        const $wrapper = $("#documentationDetailSection > div.wrapper");
        const $animationContents = $("div.doc-details-PATH, div.path-dashboard > .bottomOptionsBar");
        const $actionButtons = $("div.path-action-buttons-container");
        const $animationPathWall = $("div.doc-details-PATH, div.path-wall-course-container");
        const $animationBottomOptionsBar = $("div.path-dashboard > .bottomOptionsBar");
        const $pathDashboard = $("div.path-dashboard");
        const pathData = this._documentationPathData.getPathData();
        const pathMode = pathData.mode;
        const pathModes = this.getPathModes();

        $wrapper.addClass("is-index-opened");
        $actionButtons.addClass("is-index-opened");
        $wrapper.height("100vh");
        $screenHeader.hide();

        if (pathMode === pathModes.WALL_MODE) {

            $animationPathWall.animate({left: this._indexAnimationWidth}, this._indexAnimationSpeed);
            $animationBottomOptionsBar.animate({left: this._indexAnimationWidth}, this._indexAnimationSpeed);

        } else {

            $animationContents.animate({left: this._indexAnimationWidth}, this._indexAnimationSpeed);

        }

    }

    hideIndex() {

        function _onHideIndexComplete() {

            $screenHeader.show();
            $wrapper.height(DocumentationUtils.calcDetailsViewHeight());
            $wrapper.removeClass("is-index-opened");
            $animationContents.css({right: "auto"});
            $closeIndexButton.removeClass("is-index-opened");

            if (pathMode !== pathModes.WALL_MODE) {
                $animationContents.css({left: "auto"});
            }

        }

        const $screenHeader = $("#documentation-full-screen-header");
        const $wrapper = $("#documentationDetailSection > div.wrapper");
        const $animationContents = $("div.doc-details-PATH, div.path-dashboard > .bottomOptionsBar");
        const $actionButtons = $("div.path-action-buttons-container");
        const $animationPathWall = $("div.doc-details-PATH, div.path-wall-course-container");
        const $animationBottomOptionsBar = $("div.path-dashboard > .bottomOptionsBar");
        const pathData = this._documentationPathData.getPathData();
        const pathMode = pathData.mode;
        const pathModes = this.getPathModes();

        this._documentationPathData.setIndexOpened(false);

        if (pathMode === pathModes.WALL_MODE) {

            $actionButtons.removeClass("is-index-opened");
            $animationPathWall.animate({right: 0}, this._indexAnimationSpeed, _onHideIndexComplete);
            $animationBottomOptionsBar.animate({right: 0}, this._indexAnimationSpeed, _onHideIndexComplete);

        } else {

            $actionButtons.removeClass("is-index-opened");
            $animationContents.animate({right: 0}, this._indexAnimationSpeed, _onHideIndexComplete);

        }

    }

    setSmartListPathProgress(document, pathData, noNeedParse = false) {
        if(!pathData) {
            return;
        }

        pathData = noNeedParse ? pathData : this._documentationPathUtils.parseJsonResponse(pathData);

        const documentationProgress = documentationScreenController.documentationProgress;
        const documentId = document.id;
        const $smartList = $("div.bf-smart-list[data-document=" + documentId + "]");
        const $SLPathProgress = $smartList.find(".path-progress");
        const $SLTitle = $smartList.find(".title");
        let progressLineHtml = "";

        if (world.shows_completion) {

            if (pathData.progressState.state !== documentationProgress.COMPLETED) {

                $SLTitle.addClass("has-linear-progress-bar");
                progressLineHtml = "<div class='linear-progress-bar'>" +
                    "<div class='completed-percentage colorOK-background' style='width:" + pathData.progressState.percentage + "%'></div>" +
                    "</div>";

            }
        }

        $SLPathProgress.html(progressLineHtml);
    }

    updateSmartListPathProgress(documentId, pathData) {

        const documentationProgress = documentationScreenController.documentationProgress;

        const $smartList = $("div.bf-smart-list[data-document=" + documentId + "]");
        const $SLPathProgress = $smartList.find(".path-progress");
        const $SLPathProgressPercentage = $smartList.find(".completed-percentage");
        const $SLTitle = $smartList.find(".title");

        if (world.shows_completion) {

            if (pathData.progressState.state !== documentationProgress.COMPLETED) {

                $SLPathProgressPercentage.width(pathData.progressState.percentage + "%");

            } else {

                $SLTitle.removeClass("has-linear-progress-bar");
                $SLPathProgress.html(null);

            }

        }

    }

    setSmartListPathIndicators(document, pathData) {

        function _clearIndicators() {

            const $testStatusTag = $("#test-status-" + document.id);
            const $progressIcon = $(".bf-smart-list .doc-monitor-progress-icon-" + document.id);

            $testStatusTag.remove();
            $progressIcon.remove();

        }

        function _setCompletedIndicators() {
            if (pathData.progressState.state === documentationProgress.COMPLETED) {

                if (pathHasTest && pathData.test.document.completed) {

                    indicatorsHtml = "<div id='test-status-" + document.id + "' class='test-status-tag " + boxedColor + "'>" +
                        "<span class='tag-text fw-medium'>" + pathTestTr + "</span>" +
                        "<span class='tag-text fw-bold'>&nbsp;" + pathTestBestNote + "</span>" +
                        "</div>";

                } else if (!pathHasTest) {

                    indicatorsHtml = "<div id='test-status-" + document.id + "' class='test-status-tag colorOK-background'>" +
                        "<span class='tag-text fw-medium'>" + Translator.trans("TR_COMPLETADO") + "</span>" +
                        "</div>";

                }

            }

        }

        function _setWallViewIndicators() {

            if (pathData.progressState.state === documentationProgress.COMPLETED) {
                _setCompletedIndicators();
            }

            if (pathData.progressState.state === documentationProgress.IN_PROCESS) {

                if (pathHasTest && pathTestAttempted) {

                    indicatorsHtml = "<div id='test-status-" + document.id + "' class='test-status-tag tried'>" +
                        "<span class='tag-text colorERROR-text fw-medium'>" + Translator.trans("TR_NO_SUPER") + "</span>" +
                        "<span class='tag-text colorERROR-text fw-bold'>&nbsp;" + formatValueByLocale(pathTestBestNote) + "</span>" +
                        "</div>";

                } else {
                    //<p class='document-progress-state-text in-progress path-state'>${Translator.trans("TR_EN_PROCESO")}</p>
                    indicatorsHtml = `<div class='doc-monitor-progress-icon-${document.id} progress-icon d-flex'>
                                        <p class='document-progress-state-text in-progress'>${Translator.trans("TR_EN_PROCESO")}</p>
                                        <svg id="_--ico-content-in-process-16" class="document-progress-state-icon" data-name="//--ico-content-in-process-16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                            <path id="Trazado_6337" data-name="Trazado 6337" d="M0,0H16V16H0Z" fill="rgba(0,0,0,0)"></path>
                                            <circle id="Elipse_177" data-name="Elipse 177" cx="6" cy="6" r="6" transform="translate(2 2)" fill="#ff8d0a" stroke="#ff8d0a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></circle>
                                        </svg>
                                      </div>`;

                }

            }

            if (pathData.progressState.state === documentationProgress.NOT_STARTED) {

                indicatorsHtml = "<div class='doc-monitor-progress-icon-" + document.id + " progress-icon d-flex'>" +
                    "<p class='document-progress-state-text path-state not-started'>" + Translator.trans("TR_SIN_INICIAR") + "</p>" +
                    "</div>";

            }

        }

        const documentationProgress = documentationScreenController.documentationProgress;
        const documentId = document.id;

        let pathHasTest = false;
        let pathTestAttempted = false;
        let pathTestPassed = false;
        let pathTestBestNote = null;

        if (pathData.test.document && pathData.test.enabled) {
            pathHasTest = pathData.test.enabled;
            pathTestAttempted = pathData.test.document.own_test && pathData.test.document.own_test.games.length > 0;
            pathTestPassed = pathTestAttempted && pathData.test.document.own_test.best_game.qualification >= pathData.test.document.own_test.minimum_qualification;
            pathTestBestNote = pathTestAttempted ? formatValueByLocale(pathData.test.document.own_test.best_game.qualification) : null;
        }

        const pathTestTr = pathTestPassed ? Translator.trans("TR_SUPERADO") : Translator.trans("TR_NO_SUPER");
        const boxedColor = pathTestPassed ? "colorOK-background" : "colorERROR-background";
        const $smartList = $("div.bf-smart-list[data-document=" + documentId + "]");
        const isSmartListWall = $smartList.data("list") === "WALL";
        const $SLPathIndicators = $smartList.find(".indicators");
        let indicatorsHtml = "";

        // Eliminar los indicadores actuales del path para actualizarlos con los nuevos
        _clearIndicators();

        if (world.shows_completion) {

            // La vista muro tiene mas estados que indican el estado del path (Sin iniciar y en proceso)
            if (isSmartListWall) {
                _setWallViewIndicators();
                // Las demas vistas tienen el indicador de completado / superado - no superado + nota
            } else {
                _setCompletedIndicators();
            }

        }

        $SLPathIndicators.prepend(indicatorsHtml);
    }

    updateSmartListPathIndicators(documentId, pathData) {

        const document = documentationScreenController.getDocument(documentId);
        this.setSmartListPathIndicators(document, pathData);

    }

    setSmartListPathTime(document, pathData) {

        if (world.shows_completion) {

            const $smartList = $("div.bf-smart-list[data-document=" + document.id + "]");
            const $completedTimeText = $smartList.find(".completion-time-text");

            $completedTimeText.text(pathData.etaFormatted);

        }

    }

    //set last scroll position in current position (applied to path)
    saveYScrollPosition() {
        //set last scroll position
        const wrapperPath = $(window).width() >= 1280 ? '.wrapper-desktop-path' : '.wrapper-path';
        const yScrollPosition = window.document.querySelector(wrapperPath).scrollTop;

        this._lastYScrollPosition = yScrollPosition;
    }

    /**
     * Get path item using document id.
     * We have 2 types of documents, normal without path information and path documents with path information.
     * @param pathData
     * @param documentId
     */
    getPathItem(pathData, documentId) {
        try {
            let currentDocument = null;

            pathData.sections.forEach(section => {
                section.items.forEach(item => {
                    if (item.id === documentId) {
                        currentDocument = item;
                    }
                })
            });

            return currentDocument;
        } catch (e) {
            return null;
        }
    }

    getSectionId(pathData, pathItemId) {
        const sectionItemDict = pathData.sectionItemsDict[pathItemId];

        return sectionItemDict?.id;
    }

    updateInstagramProgressLinearBar(percentage) {
        document
            .querySelector('.path-express-view .linear-progress-bar')
            .innerHTML = `<div class='completed-percentage colorOK-background' style='width:${percentage}%'></div>`;
    }

    updateInstagramPathState(state) {
        const pathState = document.querySelector('.path-info .path-bullets-data .path-state');

        if(!pathState && !pathState?.dataset) {
            return;
        }

        pathState.dataset.state = state;

        if (state === 'COMPLETED') {
            pathState.innerHTML = `<div class="test-status-tag colorOK-background">
                <span class="tag-text fw-medium">${Translator.trans("TR_COMPLETADO")}</span>
            </div>`;
        }

        if (state === 'IN_PROCESS') {
            pathState.innerHTML = `<div class="document-progress-state-text in-progress">
                <span class="tag-text fw-medium">${Translator.trans("TR_EN_PROCESO")}</span>
            </div>`;
        }
    }

    //UNLOCK DOCUMENTS IN PATH INSTAGRAM -> refreshPath()
    unlockNextDocumentPath({pathData, currentDocument}) {
        const {pathItemId} = this.getPathItem(pathData, currentDocument.id);
        const sectionId = this.getSectionId(pathData, pathItemId);

        //set completed current document
        this._documentationPathData.updatePathDocument(sectionId, currentDocument.id); //update completed fields
        this._documentationPathData.updateProgressStatePercentage(); //update progressState (percentage & state)

        const updatedPathData = this._documentationPathData.getPathData();

        this.updateInstagramProgressLinearBar(updatedPathData?.progressState?.percentage ?? 0);
        this.updateInstagramPathState(updatedPathData?.progressState?.state ?? 'NOT_STARTED');

        const pathUtils = documentationScreenController.documentationPath.getPathUtils();
        const nextDocumentToComplete = pathUtils.getNextClassToComplete(updatedPathData);

        if(!nextDocumentToComplete) {
            return;
        }

        /**
         *  unblock next document
         */
        const newNextDocumentToComplete = {
            ...nextDocumentToComplete,
            is_blocked: false,
            isBlocked: false,
            is_completed: false,
            progressState: 'NOT_STARTED',
        };

        // Update next document to complete
        const nextSectionId = this.getSectionId(updatedPathData, newNextDocumentToComplete.pathItemId);

        if(currentDocument.id !== newNextDocumentToComplete.id) { //if next document is in another section
            this._documentationPathData.updatePathDocument(
                nextSectionId,
                newNextDocumentToComplete.id,
                newNextDocumentToComplete
            );
        } else {
            throw('interest: next document is in the same section');
        }

        this._documentationPathData.updateProgressStatePercentage(); //update progressState (percentage & state)

        this.setSmartListPathProgress(newNextDocumentToComplete, updatedPathData, true);
        this.updateSmartListPathProgress(newNextDocumentToComplete.id, updatedPathData);
        this.updateSmartListPathIndicators(newNextDocumentToComplete.id, updatedPathData);
        this.setSmartListPathTime(newNextDocumentToComplete, updatedPathData);

        // Update progress state percentage (HTML)

        const docEl = document.querySelector(
            `.documentation-advanced-documents-row[data-document="${newNextDocumentToComplete.id}"]`
        );

        if (docEl) {
            //remove unused class
            if(docEl.querySelector('p.document-progress-state-text.path-state')) {
                docEl.querySelector('p.document-progress-state-text.path-state')
                    .classList
                    .remove('path-state')
            }

            if(docEl.querySelector('.bf-smart-list.path-wall-course-item')) {
                docEl.querySelector('.bf-smart-list.path-wall-course-item').dataset.blocked = 'false';
            }

            if (docEl.querySelector('.locked-content')) {
                docEl.querySelector('.locked-content').style.display = 'none';
            }

            if (docEl.querySelector('.locked-text')) {
                docEl.querySelector('.locked-text').style.display = 'none';
            }

            if (docEl.querySelector('.locked-icon')) {
                docEl.querySelector('.locked-icon').style.display = 'none';
            }
        }
    }

    initialize(pathDocumentId) {
        window.isEnablePathScope = true;

        const pathData = this._documentationPathData.getPathData();
        const pathModes = this.getPathModes();
        const documentationProgress = documentationScreenController.documentationProgress;

        this._enableHandlers();
        this.setReturnToPath(false);
        this._documentationPathUtils.setPathEllipsis();
        this._documentationPathUtils.tintPathIcons();
        this._documentationPathUtils.setIndexContentHeight();
        this._documentationPathData.setPathDocumentId(pathDocumentId);

        if (pathData.progressState.state === documentationProgress.COMPLETED) {
            documentationProgress.setCompleted(pathDocumentId);
        }

        if (this.getOpenTestOnLoad()) {

            this.onClickTestButton();
            this.setOpenTestOnLoad(false);

        }

        if (this.getIsLmsPath()) {

            this._documentationPathLms.blockPathExit();
            this._documentationPathLms.setData(pathData);
            this._documentationPathLms.sendPathProgress(pathData);

        }

        if (pathData.mode === pathModes.WIZARD_MODE) {
            this._wizardMode = new DocumentationPathWizard();
            this._wizardMode.enableHandlers();
            this._wizardMode.enablePreviewHandlers();
            this._wizardMode.setWizardCarousel(this._wizardItemIndex);
        }

        if (pathData.mode === pathModes.MONO_MODE) {
            this._monoMode = new DocumentationPathMono();
            this._monoMode.enableHandlers();
        }

        //Instagram & Express
        if (pathData.mode === pathModes.WALL_MODE) {

            this._wallMode = new DocumentationPathWall();
            this._wallMode.setWallContainerManager();
            this._wallMode.setWallDescriptionAccordion();
            this._wallMode.setWallPlayEventHandlers();
            this._wallMode.setWallPieChart();
            this._wallMode.setWallBackgroundsIcons();
            this._wallMode.setWallImageRatings();
            this._wallMode.setWallTintIcons();
            this._wallMode.enableHandlers(pathData.coverName === "WALL");

            // Path Instagram
            if (pathData.coverName === "WALL") {
                documentationScreenController.reDrawFolder = true;
                this._wallMode.setWallInstagramHeaders();
            }

            // Path Express y Por pasos
            if (pathData.coverName === "CARD_ART") {
                this._wallMode.setWallExpressHeaders();
            }

            // Carousel settings
            setTimeout(() => {
                this._wallMode.setWallCarrouselEventHandlers();
            }, 500);
        }
    }

}